import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AppContext } from '../../../App.context';
import PrivateRoute from './PrivateRoute';

export default function ProtectedRoute({ children }) {
  const { appState } = useContext(AppContext);

  if (appState.role === 'user' || appState.role === 'guest') {
    return <Navigate to="/upsell/upsells" />;
  }

  return <PrivateRoute>{children}</PrivateRoute>;
}
